function calculatorBlock() {
  const calculators = document.querySelectorAll(".js-calculator");

  if (!calculators.length) {
    return;
  }

  calculators.forEach((calculator) => {
    const resetButton = calculator.querySelector(".js-calculator-reset");

    if (!resetButton) {
      return;
    }

    resetButton.addEventListener("click", () => {
      calculator.querySelectorAll(".calculator-field").forEach((field) => {
        field.value = field.defaultValue;
      });
    });
  });
}

function carouselBlock() {
  if (typeof $ === "undefined" || typeof $.fn.slick === "undefined") {
    return;
  }

  $(".js-carousel").each(function initCarousel() {
    const $track = $(this);
    const $wrap = $track.closest(".carousel__wrap");

    $track.slick({
      infinite: true,
      speed: 400,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      prevArrow: $wrap.find(".js-carousel-prev"),
      nextArrow: $wrap.find(".js-carousel-next"),
      dots: true,
      appendDots: $wrap.find(".js-carousel-dots"),
    });
  });
}

function emailTrayBlock() {
  const tray = document.querySelector(".js-email-tray");

  if (!tray) {
    return;
  }

  const toggle = tray.querySelector(".js-email-tray-toggle");
  const countEl = tray.querySelector(".js-email-tray-count");
  const items = Array.from(tray.querySelectorAll(".js-email-tray-item"));
  const clearButton = tray.querySelector(".js-email-tray-clear");

  const getSheetByIndex = (index) =>
    document.querySelector(`.js-tech-sheet-email[data-index="${index}"]`);

  const setSheetSelected = (button, isSelected) => {
    button.classList.toggle("is-selected", isSelected);
    button.setAttribute("aria-pressed", isSelected ? "true" : "false");
  };

  const render = () => {
    let selectedCount = 0;

    items.forEach((item) => {
      const sheet = getSheetByIndex(item.dataset.index);
      const isSelected = !!sheet && sheet.classList.contains("is-selected");

      item.hidden = !isSelected;

      if (isSelected) {
        selectedCount += 1;
      }
    });

    tray.hidden = !selectedCount;

    if (!selectedCount) {
      return;
    }

    countEl.textContent = `${selectedCount} File${selectedCount === 1 ? "" : "s"} Attached`;
  };

  document.querySelectorAll(".js-tech-sheet-email").forEach((button) => {
    button.addEventListener("click", render);
  });

  items.forEach((item) => {
    const removeButton = item.querySelector(".js-email-tray-remove");

    if (!removeButton) {
      return;
    }

    removeButton.addEventListener("click", () => {
      const sheet = getSheetByIndex(item.dataset.index);

      if (sheet) {
        setSheetSelected(sheet, false);
        render();
      }
    });
  });

  if (toggle) {
    toggle.addEventListener("click", () => {
      const isExpanded = tray.classList.toggle("is-expanded");

      toggle.setAttribute("aria-expanded", isExpanded ? "true" : "false");
    });
  }

  if (clearButton) {
    clearButton.addEventListener("click", () => {
      items.forEach((item) => {
        const sheet = getSheetByIndex(item.dataset.index);

        if (sheet) {
          setSheetSelected(sheet, false);
        }
      });

      render();
    });
  }

  render();
}

function flipCardBlock() {
  const cards = document.querySelectorAll(".js-flip-card");

  if (!cards.length) {
    return;
  }

  cards.forEach((card) => {
    const front = card.querySelector('[class*="__face--front"]');
    const back = card.querySelector('[class*="__face--back"]');
    const triggers = card.querySelectorAll(".js-flip-card-trigger");

    if (!front || !back || !triggers.length) {
      return;
    }

    const setFlipped = (isFlipped) => {
      card.classList.toggle("is-flipped", isFlipped);

      front.setAttribute("aria-hidden", isFlipped ? "true" : "false");
      back.setAttribute("aria-hidden", isFlipped ? "false" : "true");

      if (isFlipped) {
        front.setAttribute("inert", "");
        back.removeAttribute("inert");
      } else {
        back.setAttribute("inert", "");
        front.removeAttribute("inert");
      }
    };

    card.flipCardSetFlipped = setFlipped;

    triggers.forEach((trigger) => {
      trigger.addEventListener("click", () => {
        setFlipped(!card.classList.contains("is-flipped"));
        syncFlipAllState(card);
      });
    });
  });
}

// Keeps a group's "Flip All" trigger honest when cards are flipped one-by-one
// via their own icons: if every card ends up flipped, force Flip All active;
// if every card ends up unflipped, force it inactive. A mixed state leaves
// Flip All's own toggle state untouched.
function syncFlipAllState(card) {
  const group = card.closest(".js-flip-cards-group");

  if (!group) {
    return;
  }

  const allTrigger = group.querySelector(".js-flip-all-trigger");

  if (!allTrigger) {
    return;
  }

  const groupCards = group.querySelectorAll(".js-flip-card");
  const allFlipped = Array.from(groupCards).every((c) =>
    c.classList.contains("is-flipped"),
  );
  const noneFlipped = Array.from(groupCards).every(
    (c) => !c.classList.contains("is-flipped"),
  );

  if (allFlipped) {
    allTrigger.classList.add("is-active");
  } else if (noneFlipped) {
    allTrigger.classList.remove("is-active");
  }
}

function flipAllBlock() {
  const triggers = document.querySelectorAll(".js-flip-all-trigger");

  if (!triggers.length) {
    return;
  }

  triggers.forEach((trigger) => {
    trigger.addEventListener("click", () => {
      const group = trigger.closest(".js-flip-cards-group");

      if (!group) {
        return;
      }

      // Flip All has its own toggle state (its "is-active" class) — clicking
      // it always flips that state, regardless of what any individual card
      // is currently doing. Whichever state it lands on becomes the target
      // applied to every card: cards already matching stay put, the rest flip.
      const target = !trigger.classList.contains("is-active");
      const cards = group.querySelectorAll(".js-flip-card");

      cards.forEach((card) => {
        if (typeof card.flipCardSetFlipped === "function") {
          card.flipCardSetFlipped(target);
        }
      });

      trigger.classList.toggle("is-active", target);
    });
  });
}

// Native `required` on a checkbox means that one checkbox must be checked —
// there's no built-in "at least one of this group" semantics like radios have.
// For a checkbox group marked required (multiselect fields styled as radios),
// keep `required` on every box in the group only while none of them are
// checked, so the group blocks submission until at least one is picked.
function requiredCheckboxGroupsBlock() {
  const groupNames = new Set();

  document.querySelectorAll("[data-required-group]").forEach((input) => {
    groupNames.add(input.getAttribute("data-required-group"));
  });

  if (!groupNames.size) {
    return;
  }

  groupNames.forEach((groupName) => {
    const boxes = Array.from(
      document.querySelectorAll(`[data-required-group="${groupName}"]`),
    );

    if (!boxes.length) {
      return;
    }

    const sync = () => {
      const anyChecked = boxes.some((box) => box.checked);

      boxes.forEach((box) => {
        box.required = !anyChecked;
      });
    };

    boxes.forEach((box) => {
      box.addEventListener("change", sync);
    });

    sync();
  });
}

function validatePhoneInput(input) {
  const value = input.value.trim();

  if (!value) {
    input.setCustomValidity("");
    return;
  }

  if (!/^\+?[0-9\s\-().]+$/.test(value)) {
    input.setCustomValidity(
      "Use numbers only, with optional +, spaces, dashes, or parentheses.",
    );
    return;
  }

  const digitCount = value.replace(/\D/g, "").length;

  if (digitCount < 7) {
    input.setCustomValidity("Enter a valid phone or mobile number.");
    return;
  }

  input.setCustomValidity("");
}

function phoneValidationBlock() {
  document.querySelectorAll('[data-validate="phone"]').forEach((input) => {
    const sync = () => validatePhoneInput(input);

    input.addEventListener("input", sync);
    input.addEventListener("blur", sync);
  });
}

function formBlock() {
  const forms = document.querySelectorAll(".js-form");

  if (!forms.length) {
    return;
  }

  forms.forEach((form) => {
    const thanks = form.parentElement.querySelector(".js-form-thanks");

    if (!thanks) {
      return;
    }

    form.addEventListener("submit", (event) => {
      event.preventDefault();

      form
        .querySelectorAll('[data-validate="phone"]')
        .forEach(validatePhoneInput);

      if (!form.reportValidity()) {
        return;
      }

      form.hidden = true;
      thanks.hidden = false;
      thanks.focus();
    });
  });
}

// Header sticky on scroll
let lastScrollTop = 0;
const headerSticky = () => {
  if ($(".header").length > 0) {
    let scrollTop = $(window).scrollTop();
    const header = $(".header");

    if (scrollTop > 10) {
      header.addClass("is-sticky");
    } else {
      header.removeClass("is-sticky");
    }
    lastScrollTop = scrollTop;
  }
};

function updateAppHeaderHeight() {
  const header = document.querySelector(".header");

  if (!header) {
    return;
  }

  if (document.body.classList.contains("is-fullscreen")) {
    document.documentElement.style.setProperty("--app-header-height", "0px");
    return;
  }

  const height = Math.ceil(header.getBoundingClientRect().height);

  document.documentElement.style.setProperty(
    "--app-header-height",
    `${height}px`,
  );
}

function setAppHeaderHeight() {
  const header = document.querySelector(".header");

  if (!header) {
    return;
  }

  updateAppHeaderHeight();

  if (typeof ResizeObserver !== "undefined") {
    const observer = new ResizeObserver(updateAppHeaderHeight);

    observer.observe(header);
  } else {
    window.addEventListener("resize", updateAppHeaderHeight);
  }
}

function closeSidenav() {
  const sidenav = document.getElementById("app-sidebar");
  const toggle = document.querySelector(".header__sidebar-toggle");
  const backdrop = document.querySelector(".sidenav-backdrop");

  if (!document.body.classList.contains("is-sidenav-open")) {
    return;
  }

  document.body.classList.remove("is-sidenav-open");

  if (sidenav) {
    sidenav.classList.remove("sidenav--open");
    sidenav.setAttribute("aria-hidden", "true");
  }

  if (toggle) {
    toggle.setAttribute("aria-expanded", "false");
  }

  if (backdrop) {
    backdrop.setAttribute("aria-hidden", "true");
  }
}

function sidenavToggle() {
  const toggle = document.querySelector(".header__sidebar-toggle");
  const sidenav = document.getElementById("app-sidebar");
  const backdrop = document.querySelector(".sidenav-backdrop");

  if (!toggle || !sidenav) {
    return;
  }

  const setOpen = (isOpen) => {
    document.body.classList.toggle("is-sidenav-open", isOpen);
    sidenav.classList.toggle("sidenav--open", isOpen);
    sidenav.setAttribute("aria-hidden", isOpen ? "false" : "true");
    toggle.setAttribute("aria-expanded", isOpen ? "true" : "false");

    if (backdrop) {
      backdrop.setAttribute("aria-hidden", isOpen ? "false" : "true");
    }
  };

  toggle.addEventListener("click", () => {
    setOpen(!document.body.classList.contains("is-sidenav-open"));
  });

  if (backdrop) {
    backdrop.addEventListener("click", () => setOpen(false));
  }

  document.addEventListener("keydown", (event) => {
    if (
      event.key === "Escape" &&
      document.body.classList.contains("is-sidenav-open")
    ) {
      setOpen(false);
      toggle.focus();
    }
  });
}

function fullscreenToggle() {
  const button = document.querySelector(".js-fullscreen");

  if (!button) {
    return;
  }

  const syncState = (isActive) => {
    document.body.classList.toggle("is-fullscreen", isActive);
    button.setAttribute("aria-pressed", isActive ? "true" : "false");
    button.setAttribute(
      "aria-label",
      isActive ? "Exit full screen" : "Enter full screen",
    );
    button.setAttribute("title", isActive ? "Exit full screen" : "Full screen");
    button.classList.toggle("is-active", isActive);
    updateAppHeaderHeight();

    if (isActive) {
      closeSidenav();
    }
  };

  button.addEventListener("click", () => {
    syncState(!document.body.classList.contains("is-fullscreen"));
  });

  document.addEventListener("keydown", (event) => {
    if (
      event.key === "Escape" &&
      document.body.classList.contains("is-fullscreen")
    ) {
      syncState(false);
      button.focus();
    }
  });

  syncState(false);
}

function accordionBlock() {
  const items = document.querySelectorAll(".js-accordion-item");

  if (!items.length) {
    return;
  }

  const setPanelState = (item, trigger, panel, isOpen) => {
    item.classList.toggle("is-open", isOpen);
    trigger.setAttribute("aria-expanded", isOpen ? "true" : "false");
    panel.setAttribute("aria-hidden", isOpen ? "false" : "true");

    if (isOpen) {
      panel.removeAttribute("inert");
    } else {
      panel.setAttribute("inert", "");
    }
  };

  items.forEach((item) => {
    const trigger = item.querySelector(".js-accordion-trigger");
    const panel = item.querySelector(".js-accordion-panel");

    if (!trigger || !panel) {
      return;
    }

    setPanelState(item, trigger, panel, item.classList.contains("is-open"));

    trigger.addEventListener("click", () => {
      setPanelState(item, trigger, panel, !item.classList.contains("is-open"));
    });
  });
}

//Cursor
function cursorClick() {
  $("a").each(function () {
    let href = $(this).attr("href");
    if (!href || href === "#" || href === "#0" || href === "#!") {
      $(this).addClass("is-unclickable");
    }
  });
}

$(document).ready(function () {
  setAppHeaderHeight();
  sidenavToggle();
  accordionBlock();
  fullscreenToggle();
  initPagination();
  initVideoModal();
  flipCardBlock();
  flipAllBlock();
  timelineBlock();
  carouselBlock();
  tabsBlock();
  requiredCheckboxGroupsBlock();
  phoneValidationBlock();
  formBlock();
  techSheetsBlock();
  techSheetsSearchBlock();
  emailTrayBlock();
  calculatorBlock();
});

$(window).on("load", function () {
  cursorClick();
});

function getPaginationVisibleItems(pages, current) {
  const total = pages.length;
  const firstPage = pages[0];
  const lastPage = pages[total - 1];
  const items = [];

  // ≤6 show all; >6 show 1–5 … last (slide near end / middle)
  if (total <= 6) {
    pages.forEach((page) => {
      items.push({ type: "page", page });
    });
    return items;
  }

  if (current <= 5) {
    for (let index = 0; index < 5; index += 1) {
      items.push({ type: "page", page: pages[index] });
    }
    items.push({ type: "ellipsis" });
    items.push({ type: "page", page: lastPage });
    return items;
  }

  if (current >= lastPage - 4) {
    items.push({ type: "page", page: firstPage });
    items.push({ type: "ellipsis" });
    for (let index = total - 5; index < total; index += 1) {
      items.push({ type: "page", page: pages[index] });
    }
    return items;
  }

  items.push({ type: "page", page: firstPage });
  items.push({ type: "ellipsis" });
  items.push({ type: "page", page: current - 1 });
  items.push({ type: "page", page: current });
  items.push({ type: "page", page: current + 1 });
  items.push({ type: "ellipsis" });
  items.push({ type: "page", page: lastPage });
  return items;
}

function setPaginationControlState(control, href, disabled) {
  if (!control) {
    return;
  }

  control.href = href;
  control.setAttribute("aria-disabled", disabled ? "true" : "false");

  if (
    control.classList.contains("js-pagination-first") ||
    control.classList.contains("js-pagination-last")
  ) {
    control.classList.toggle("pagination__skip--disabled", disabled);
  } else {
    control.classList.toggle("pagination__nav--disabled", disabled);
  }

  if (disabled) {
    control.setAttribute("tabindex", "-1");
  } else {
    control.removeAttribute("tabindex");
  }
}

function updatePagination(root) {
  const current = Number(root.getAttribute("data-current")) || 1;
  const pageLinks = Array.from(root.querySelectorAll(".js-pagination-page"));
  const pages = pageLinks.map((link) => Number(link.getAttribute("data-page")));

  if (!pages.length) {
    return;
  }

  const firstPage = pages[0];
  const lastPage = pages[pages.length - 1];
  const currentIndex = pages.indexOf(current);
  const safeIndex = currentIndex === -1 ? 0 : currentIndex;
  const prevPage = pages[Math.max(0, safeIndex - 1)];
  const nextPage = pages[Math.min(pages.length - 1, safeIndex + 1)];
  const isFirst = current <= firstPage;
  const isLast = current >= lastPage;
  const visibleItems = getPaginationVisibleItems(pages, current);
  const visiblePages = visibleItems
    .filter((item) => item.type === "page")
    .map((item) => item.page);

  const firstHref =
    root.querySelector(`.js-pagination-page[data-page="${firstPage}"]`)?.href ||
    "#";
  const lastHref =
    root.querySelector(`.js-pagination-page[data-page="${lastPage}"]`)?.href ||
    "#";
  const prevHref =
    root.querySelector(`.js-pagination-page[data-page="${prevPage}"]`)?.href ||
    "#";
  const nextHref =
    root.querySelector(`.js-pagination-page[data-page="${nextPage}"]`)?.href ||
    "#";

  setPaginationControlState(
    root.querySelector(".js-pagination-first"),
    firstHref,
    isFirst,
  );
  setPaginationControlState(
    root.querySelector(".js-pagination-prev"),
    prevHref,
    isFirst,
  );
  setPaginationControlState(
    root.querySelector(".js-pagination-next"),
    nextHref,
    isLast,
  );
  setPaginationControlState(
    root.querySelector(".js-pagination-last"),
    lastHref,
    isLast,
  );

  pageLinks.forEach((link) => {
    const page = Number(link.getAttribute("data-page"));
    const isVisible = visiblePages.includes(page);
    const isCurrent = page === current;

    link.hidden = !isVisible;
    link.classList.toggle("pagination__page--current", isCurrent);

    if (isCurrent) {
      link.setAttribute("aria-current", "page");
    } else {
      link.removeAttribute("aria-current");
    }
  });

  root.querySelectorAll(".js-pagination-ellipsis").forEach((ellipsis) => {
    const afterPage = Number(ellipsis.getAttribute("data-after"));
    const afterIndex = visiblePages.indexOf(afterPage);
    const nextVisible = afterIndex === -1 ? null : visiblePages[afterIndex + 1];
    const showEllipsis =
      afterIndex !== -1 && nextVisible !== null && nextVisible > afterPage + 1;

    ellipsis.hidden = !showEllipsis;
  });
}

function initPagination() {
  const roots = document.querySelectorAll(".js-pagination");

  if (!roots.length) {
    return;
  }

  roots.forEach((root) => updatePagination(root));
}

function tabsBlock() {
  document.querySelectorAll(".js-tabs").forEach((tablistRoot) => {
    const group = tablistRoot.dataset.tabGroup;

    if (!group) {
      return;
    }

    const panelsRoot = document.querySelector(
      `.js-tab-panels[data-tab-group="${group}"]`,
    );

    if (!panelsRoot) {
      return;
    }

    const tabs = [...tablistRoot.querySelectorAll('[role="tab"]')];
    const panels = [...panelsRoot.querySelectorAll('[role="tabpanel"]')];

    if (!tabs.length || tabs.length !== panels.length) {
      return;
    }

    const activateTab = (index) => {
      tabs.forEach((tab, tabIndex) => {
        const isActive = tabIndex === index;

        tab.setAttribute("aria-selected", isActive ? "true" : "false");
        tab.tabIndex = isActive ? 0 : -1;
        tab.classList.toggle("filter-pills__item--active", isActive);
      });

      panels.forEach((panel, panelIndex) => {
        const isActive = panelIndex === index;

        panel.hidden = !isActive;
        panel.classList.toggle("is-active", isActive);

        if (isActive) {
          panel.removeAttribute("inert");
        } else {
          panel.setAttribute("inert", "");
        }
      });
    };

    const focusTab = (index) => {
      const nextIndex = (index + tabs.length) % tabs.length;

      activateTab(nextIndex);
      tabs[nextIndex].focus();
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener("click", () => {
        activateTab(index);
      });

      tab.addEventListener("keydown", (event) => {
        let targetIndex = null;

        switch (event.key) {
          case "ArrowLeft":
          case "ArrowUp":
            targetIndex = index - 1;
            break;
          case "ArrowRight":
          case "ArrowDown":
            targetIndex = index + 1;
            break;
          case "Home":
            targetIndex = 0;
            break;
          case "End":
            targetIndex = tabs.length - 1;
            break;
          default:
            break;
        }

        if (targetIndex === null) {
          return;
        }

        event.preventDefault();
        focusTab(targetIndex);
      });
    });

    const initialIndex = tabs.findIndex(
      (tab) => tab.getAttribute("aria-selected") === "true",
    );

    activateTab(initialIndex >= 0 ? initialIndex : 0);
  });
}

function techSheetsBlock() {
  const buttons = document.querySelectorAll(".js-tech-sheet-email");

  if (!buttons.length) {
    return;
  }

  buttons.forEach((button) => {
    button.addEventListener("click", () => {
      const isSelected = !button.classList.contains("is-selected");

      button.classList.toggle("is-selected", isSelected);
      button.setAttribute("aria-pressed", isSelected ? "true" : "false");
    });
  });
}

// Custom clear ("x") button for the search field — the native WebKit search
// cancel button is unreliable once appearance:none is applied to the input.
function techSheetsSearchBlock() {
  const input = document.querySelector(".js-tech-sheets-search-input");
  const clearButton = document.querySelector(".js-tech-sheets-search-clear");

  if (!input || !clearButton) {
    return;
  }

  const syncClearButton = () => {
    clearButton.hidden = !input.value;
  };

  input.addEventListener("input", syncClearButton);

  clearButton.addEventListener("click", () => {
    input.value = "";
    input.focus();
    syncClearButton();
  });

  syncClearButton();
}

function timelineBlock() {
  const rows = document.querySelectorAll(".js-timeline-row");

  if (!rows.length) {
    return;
  }

  rows.forEach((row) => {
    const group = row.closest(".js-timeline-group");
    const progressBar = group
      ? group.querySelector(".js-timeline-progress-bar")
      : null;

    const updateProgress = () => {
      if (!progressBar) {
        return;
      }

      const maxScroll = row.scrollWidth - row.clientWidth;
      const ratio = maxScroll > 0 ? row.scrollLeft / maxScroll : 0;

      progressBar.style.width = `${Math.min(100, Math.max(0, ratio * 100))}%`;
    };

    row.addEventListener("scroll", updateProgress);
    updateProgress();
  });
}

function initVideoModal() {
  const modalElement = document.querySelector(".js-video-modal");
  const triggers = document.querySelectorAll(".js-video-modal-open");

  if (!modalElement || !triggers.length || typeof bootstrap === "undefined") {
    return;
  }

  const filePlayer = modalElement.querySelector(".js-video-modal-player");
  const iframePlayer = modalElement.querySelector(".js-video-modal-iframe");
  const title = modalElement.querySelector(".js-video-modal-title");
  const modal = bootstrap.Modal.getOrCreateInstance(modalElement);

  const stopPlayers = () => {
    if (filePlayer) {
      filePlayer.pause();
      filePlayer.removeAttribute("src");
      filePlayer.load();
      filePlayer.hidden = true;
    }

    if (iframePlayer) {
      iframePlayer.removeAttribute("src");
      iframePlayer.hidden = true;
    }
  };

  const openFileVideo = (videoSrc) => {
    if (!filePlayer) {
      return;
    }

    if (iframePlayer) {
      iframePlayer.hidden = true;
      iframePlayer.removeAttribute("src");
    }

    filePlayer.hidden = false;
    filePlayer.src = videoSrc;
    filePlayer.load();

    const playPromise = filePlayer.play();

    if (playPromise && typeof playPromise.catch === "function") {
      playPromise.catch(() => {
        // Autoplay may be blocked; controls remain available.
      });
    }
  };

  const openIframeVideo = (videoSrc) => {
    if (!iframePlayer) {
      return;
    }

    if (filePlayer) {
      filePlayer.pause();
      filePlayer.removeAttribute("src");
      filePlayer.load();
      filePlayer.hidden = true;
    }

    iframePlayer.hidden = false;
    iframePlayer.src = videoSrc;
  };

  triggers.forEach((trigger) => {
    trigger.addEventListener("click", () => {
      const videoSrc = trigger.getAttribute("data-video-src");
      const videoType = trigger.getAttribute("data-video-type") || "file";
      const videoTitle = trigger.getAttribute("data-video-title") || "Video";

      if (!videoSrc) {
        return;
      }

      if (title) {
        title.textContent = videoTitle;
      }

      if (videoType === "iframe") {
        openIframeVideo(videoSrc);
      } else {
        openFileVideo(videoSrc);
      }

      modal.show();
    });
  });

  modalElement.addEventListener("hidden.bs.modal", stopPlayers);
}
